export function filterProgram() {
  const filters = document.querySelectorAll('.archive-taxonomy');
  if(filters.length){
    filters.forEach((filter) => {
      const trigger = filter.querySelector('dt');
      if(trigger){
        trigger.addEventListener('click', () => {
          const active = document.querySelector('.archive-taxonomy.is-active');
          if(active) active.classList.remove('is-active');
          filter.classList.add('is-active');
          document.body.classList.add('is-archive-taxonomy-active');
        })
      }
    });
  }
  const close = document.querySelector('.archive-taxonomy-close');
  if(close) {
    close.addEventListener('click', (e) => {
      e.preventDefault();
      if(filters.length){
        filters.forEach((filter) => {
          filter.classList.remove('is-active');
        })
        document.body.classList.remove('is-archive-taxonomy-active');
      }
    })
  }
}